import Vue from 'vue'
import VueRouter from 'vue-router'
import Base from '../views/Base.vue'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Base,
    children: [
      {
        path: '/',
        name: 'Index',
        component: Index
      },
      {
        path: 'login',
        name: 'Login',
        meta: { title: '登录' },
        component: () => import('../views/Login.vue')
      },
      {
        path: 'my/zone',
        name: 'MyZone',
        meta: { title: '个人中心', requiresToken: true },
        component: () => import('../views/my/MyZone.vue')
      },
      {
        path: 'about/lydia-sarfati',
        name: 'Lydia',
        meta: { title: '关于创始人' },
        component: () => import('../views/about/Lydia.vue')
      },
      {
        path: 'about/seaweed',
        name: 'Seaweed',
        meta: { title: '关于海藻' },
        component: () => import('../views/about/Seaweed.vue')
      },
      {
        path: 'about/science',
        name: 'Science',
        meta: { title: '实验室科技' },
        component: () => import('../views/about/Science.vue')
      },
      {
        path: 'products/:category',
        name: 'Products',
        meta: { title: '产品列表' },
        component: () => import('../views/products/List.vue')
      },
      {
        path: 'products_search/:keyword',
        name: 'ProductsSearch',
        meta: { title: '产品搜索结果' },
        component: () => import('../views/products/All.vue')
      },
      {
        path: 'product/:id',
        name: 'Product',
        meta: { title: '产品详情' },
        component: () => import('../views/products/Detail.vue')
      },
      {
        path: 'news/redbook',
        name: 'RedBook',
        meta: { title: '小红书' },
        component: () => import('../views/news/RedBook.vue')
      },
      {
        path: 'news/blog',
        name: 'Blog',
        meta: { title: '新闻资讯' },
        component: () => import('../views/news/Blog.vue')
      },
      {
        path: 'news/blog/:id',
        name: 'BlogDetail',
        meta: { title: '新闻资讯详情' },
        component: () => import('../views/news/BlogDetail.vue')
      },
      {
        path: 'contact-us',
        name: 'ContactUs',
        meta: { title: '联系我们' },
        component: () => import('../views/ContactUs.vue')
      },
      {
        path: 'anti_fake',
        name: 'AntiFake',
        meta: { title: '防伪查询' },
        component: () => import('../views/AntiFake.vue')
      },
      {
        path: 'pictures',
        name: 'Pictures',
        component: () => import(/* webpackChunkName: "about" */ '../views/Pictures.vue')
      },
      {
        path: '/about',
        name: 'About',
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      }
    ]
  },
  {
    path: '/admin',
    component: () => import('../views/Admin.vue'),
    children: [
      {
        path: 'new_blog',
        name: 'NewBlog',
        meta: { title: '添加新闻资讯', requiresToken: true, requiresAuth: true },
        component: () => import('../views/admin/NewBlog.vue')
      },
      {
        path: 'blog_list',
        name: 'BlogList',
        meta: { title: '新闻资讯列表', requiresToken: true, requiresAuth: true },
        component: () => import('../views/admin/BlogList.vue')
      },
      {
        path: 'redbook_list',
        name: 'RedBookList',
        meta: { title: '小红书内容列表', requiresToken: true, requiresAuth: true },
        component: () => import('../views/admin/RedBookList.vue')
      },
      {
        path: 'members',
        name: 'Members',
        meta: { title: '会员列表', requiresToken: true, requiresAuth: true },
        component: () => import('../views/admin/Members.vue')
      },
      {
        path: 'goods',
        name: 'Goods',
        meta: { title: '商品列表', requiresToken: true, requiresAuth: true },
        component: () => import('../views/admin/GoodsList.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    meta: { title: '404-NOTFOUND' },
    component: () => import('../views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + '|Repêchage®|瑞波琴'
  } else {
    document.title = '美国专业修护抗衰品牌，美丽来自海洋|瑞波琴(Repêchage®)官网'
  }
  const userInfo = sessionStorage.getItem('user')
  if (to.meta.requiresToken !== undefined) {
    if (userInfo == null) {
      console.log('未登录')
      next({ name: 'Login' })
    } else {
      // 已登录 可以进一步验证权限
      if (to.meta.requiresAuth !== undefined) {
        const user = JSON.parse(userInfo)
        if (user.role * 1 === 1) {
          next()
        } else {
          next({ name: 'NotFound' })
        }
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
